import { getWidget } from '@uvocore-front/utils';
import initCommonPage from './initCommonPage';

// run common page
const commonPage = document.getElementById('CommonPage');
if (commonPage) {
  getWidget({
    widgetLink: '/assets/js/commonPagesWidget.min.js',
    insertLoaderTo: '#CommonPage',
    loaderPosition: 'top',
    fn: initCommonPage,
  });
}
